import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FilePickerComponent, FilePreviewModel } from 'ngx-awesome-uploader';
import { delay, finalize, take } from 'rxjs/operators';
import { ScDialogService } from '../../../sc-dialogs/sc-dialog.service';
import { DropBoxService } from '../../form-fields/drop-box-upload/drop-box.service';
import { DemoFilePickerAdapter } from './demo-file-picker.adapter';

@Component({
  selector: 'sc-field-file-upload',
  templateUrl: './field-file-upload.component.html',
  styleUrls: ['./field-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldFileUploadComponent extends FieldType implements AfterViewInit {
  @ViewChild('uploader', { static: false }) uploader: FilePickerComponent;
  adapter = new DemoFilePickerAdapter(this._googleDriveService);
  loading: boolean;
  uploading: boolean;
  constructor(
    private _googleDriveService: DropBoxService,
    private _httpClient: HttpClient,
    private _dialogService: ScDialogService,
    private _cd: ChangeDetectorRef,
    @Inject('env') private _env: any
  ) {
    super();
  }

  ngAfterViewInit() {
    if (this.model.docLink) {
      this.loading = true;
      this._cd.markForCheck();
      const url = `${this._env.apiURL}/Files/GetFile/${this.model.docLink}`;
      this._httpClient
        .get(url, { responseType: 'arraybuffer' })
        .pipe(
          take(1),
          finalize(() => ((this.loading = false), this._cd.markForCheck())),
          delay(10)
        )
        .subscribe(data => {
          const blob = new Blob([data], { type: this.model.docType });
          const file = {
            fileId: this.model.docLink,
            file: blob,
            fileName: this.model.filename
          };
          this.uploader.files = [file];
          this.onUploadSuccess(file);
        });
    }
  }

  onUploadSuccess(e: FilePreviewModel) {
    this.formControl.setValue(e.fileId);
    this.options.resetModel({
      ...this.model,
      docType: e.file.type,
      fileName: e.fileName
    });
    this.uploading = false;
    this._cd.markForCheck();
  }

  onRemoveSuccess(e: FilePreviewModel) {
    this.formControl.setValue(null);
    this.uploader.files = [];
    this._cd.markForCheck();
  }

  onFileAdded(file: FilePreviewModel) {
    this.uploading = true;
    this._cd.markForCheck();
  }

  openFile(fileItem: FilePreviewModel) {
    this._dialogService.fileViewer(fileItem.fileName, fileItem.file.type, fileItem.file as File);
  }
}
